/* Layout */
import Layout from '../../views/layout/Layout.vue'

const ShopTheLookList = () => import(/* webpackChunkName: "shop-the-look-list" */ '@/views/shop-the-look/list')
const ShopTheLookDetail = () => import(/* webpackChunkName: "shop-the-look-detail" */ '@/views/shop-the-look/detail')

export default [
  {
    path: '/shop-the-look',
    component: Layout,
    redirect: '/shop-the-look/list',
    name: 'ShopTheLook',
    alwaysShow: true,
    meta: {
      title: 'shopTheLook',
      icon: 'home',
    },
    children: [
      {
        path: 'create',
        component: ShopTheLookDetail,
        name: 'ShopTheLookCreate',
        meta: {
          title: 'create',
          icon: 'edit',
          accessibleName: 'shop-the-look',
        },
      },
      {
        path: 'edit/:id',
        component: ShopTheLookDetail,
        props: true,
        name: 'ShopTheLookEdit',
        hidden: true,
        meta: {
          title: 'edit',
          accessibleName: 'shop-the-look',
        },
      },
      {
        path: 'list',
        component: ShopTheLookList,
        name: 'ShopTheLookList',
        meta: {
          title: 'list',
          icon: 'list',
          accessibleName: 'shop-the-look',
        },
      },
    ],
  },
]
